import { render, staticRenderFns } from "./CalculoVolumenBloques.vue?vue&type=template&id=173a8fe6"
import script from "./CalculoVolumenBloques.vue?vue&type=script&lang=js"
export * from "./CalculoVolumenBloques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports